<script>
  import Pagination from '@/components/pagination/index.vue';
  import BaseListLayout from '@/views/layout/components/BaseListLayout.vue';
  import { myMixin } from '@/mixins/mixins.js';
  import { handleSortItem } from 'utils/utils';
  import { formatDate } from 'utils/dateutils';
  import { mapActions, mapState } from 'vuex';
  import GroupSelect from '@/components/GroupSelect/index.vue';
  import AffApplicationBaseForm from '@/views/billingSending/form/AffBillingAppBaseForm.vue';
  import { getUserListByRole } from 'api/user';
  import { RoleName } from '@/assets/js/constants';
  import { getAffSendingBillingApplicationList } from 'api/affSendingBilling/application/affapplication';
  import { billingEnumMixins } from '@/mixins/billingEnumMixins';
  import { financeInfoMixins } from '@/mixins/financeInfoMixins';

  const defaultAffApplicationForm = {
    id: null,
    affiliateId: null,
    affiliateName: null,
    affCompanyPlatform: null,
  };
  export default {
    name: 'AffBillingSendingApplication',

    components: {
      AffApplicationBaseForm,
      GroupSelect,
      BaseListLayout,
      Pagination,
    },
    mixins: [myMixin, billingEnumMixins, financeInfoMixins],
    data() {
      return {
        editData: Object.assign({}, defaultAffApplicationForm),
        inputs: [{ value: '' }],
        dialogVisible: false,
        dialogType: 'new',
        changeStatus: '',
        total: 0,
        listLoading: false,
        dataList: [],
        allAmList: [],
        affIntegrationTypeList: ['Hypertap(API)', 'Adjust', 'AF', 'Other'],
        filter: {
          page: 1,
          pageSize: 10,
          applicationNumber: null,
          affCompanyPlatform: null,
          affEntity: null,
          affId: null,
          affName: null,
          amId: null,
          amName: null,
          affIntegrationType: null,
          auditStatus: null,
          sentEmail: null,
          dateRange: [formatDate(new Date(), 'yyyy-MM'), formatDate(new Date(), 'yyyy-MM')],
        },
      };
    },
    computed: {
      ...mapState({
        affiliatesGroupList: (state) => state['affiliate'].affiliatesGroupList,
        affiliateLoading: (state) => state['affiliate'].affiliateLoading,
        affBillingAppStatusList: (state) => state['enum'].billingEnum.affBillingAppStatusList,
      }),
    },
    mounted() {
      this.getAffiliateList();
      this.getAmList();
      this.handleSearch(1);
    },
    methods: {
      ...mapActions({
        getAffiliateList: 'affiliate/getAffiliateList',
      }),
      getAmList() {
        getUserListByRole(RoleName.AM)
          .then((response) => {
            if (response.result) {
              this.allAmList = response.result.map((item) => ({
                label: item.uname,
                value: item.id,
              }));
            }
          })
          .catch(() => {});
      },
      handleSizeChange(size) {
        this.filter.pageSize = size;
        this.handleSearch(1);
      },
      handleCurrentChange(currentPage) {
        this.filter.page = currentPage;
        this.handleSearch(currentPage);
      },

      handleSort(columnInfo) {
        const sortItem = handleSortItem(columnInfo);
        if (sortItem === '') {
          this.filter.sortItems = [];
          this.handleSearch(1);
          return;
        }
        this.filter.sortItems = [];
        this.filter.sortItems.push(sortItem);
        this.handleSearch(1);
      },
      handleUpdate(row) {
        this.dialogType = 'edit';
        this.dialogVisible = true;
        this.editData = Object.assign({}, row);
      },
      handleChangeStatus(row) {
        this.dialogType = 'status';
        this.dialogVisible = true;
        this.editData = Object.assign({}, row);
      },
      handleSearch(page) {
        this.listLoading = true;
        if (page) {
          this.filter.page = page;
        }
        getAffSendingBillingApplicationList(this.filter)
          .then((res) => {
            if (res) {
              const result = res.result;
              this.dataList = result.dataList;
              this.total = res.total;
            }
          })
          .catch(() => {})
          .finally(() => {
            this.listLoading = false;
          });
      },
      handleCreate() {
        this.dialogType = 'new';
        this.dialogVisible = true;
        this.editData = {
          recordDate: formatDate(new Date(), 'yyyy-MM'),
          affCompanyPlatform: null,
          affEntity: null,
        };
      },
      handleApprove() {
        this.dialogType = 'status';
        this.changeStatus = 'APPROVED';
        this.dialogVisible = true;
        this.editData = {};
      },
      handleUnApprove() {
        this.dialogType = 'status';
        this.changeStatus = 'REJECTED';
        this.dialogVisible = true;
        this.editData = {};
      },
      handleSend() {
        this.dialogType = 'status';
        this.changeStatus = 'EMAIL_SENT';
        this.dialogVisible = true;
        this.editData = {};
      },
      handleAmSelectChange(value) {
        const option = this.allAmList.find((item) => item.value === value);
        if (option) {
          this.filter.amName = option.label;
        }
      },
      handleApplicationStatus(value) {
        if (!value) {
          return '';
        }
        const option = this.affBillingAppStatusList.find((item) => item.value === value);
        return option ? option.label : value;
      },
    },
  };
</script>

<template>
  <base-list-layout :title="'Aff Billing Application'">
    <template #search>
      <el-form :inline="true" :model="filter" label-width="150px" ref="searchForm">
        <el-form-item label="Date">
          <el-date-picker
            v-model="filter.dateRange"
            format="yyyy-MM"
            :clearable="false"
            value-format="yyyy-MM"
            type="monthrange"
            align="right"
            style="width: 260px"
            unlink-panels
            range-separator="to"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="monthPickerOptions"
          />
        </el-form-item>
        <el-form-item label="Application Number">
          <el-input v-model="filter.applicationNumber"></el-input>
        </el-form-item>
        <el-form-item label="AffiliateId">
          <group-select
            v-model="filter.affId"
            :data-source="affiliatesGroupList"
            :loading="affiliateLoading"
            clearable
            :collapse-tags="true"
            filterable
            reserve-keyword
            placeholder="please select"
          />
        </el-form-item>

        <el-form-item label="AffiliateName">
          <group-select
            v-model="filter.affName"
            :data-source="affiliatesGroupList"
            :loading="affiliateLoading"
            clearable
            :collapse-tags="true"
            filterable
            reserve-keyword
            placeholder="please select"
          />
        </el-form-item>

        <el-form-item label="Aff Company Platform">
          <el-select
            v-model="filter.affCompanyPlatform"
            filterable
            clearable
            @change="handleCompanyPlatformChange(filter.affCompanyPlatform)"
          >
            <el-option
              v-for="item in companyPlatformList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Aff Entity">
          <el-select v-model="filter.affEntity" ref="companyEntityOptions" filterable clearable>
            <el-option
              v-for="item in specificCompanyEntity"
              :key="item.id"
              :label="item.companyEntity"
              :value="item.companyEntity"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="AM">
          <el-select v-model="filter.amId" filterable clearable placeholder="please select">
            <el-option
              v-for="item in allAmList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              @change="handleAmSelectChange"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Aff Integration Type">
          <el-select
            v-model="filter.affIntegrationType"
            filterable
            clearable
            placeholder="please select"
          >
            <el-option
              v-for="item in affIntegrationTypeList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Application Status">
          <el-select v-model="filter.auditStatus" filterable clearable placeholder="please select">
            <el-option
              v-for="item in affBillingAppStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Sent Email">
          <el-input v-model="filter.sentEmail"></el-input>
        </el-form-item>
      </el-form>
    </template>
    <template #search-actions>
      <el-button type="primary" @click="handleSearch(1)">Search</el-button>
      <el-button type="primary" @click="handleCreate">Create</el-button>
      <el-button type="success" @click="handleApprove">Approve</el-button>
      <el-button type="warning" @click="handleUnApprove">UnApprove</el-button>
      <el-button type="primary" @click="handleSend">Send</el-button>
    </template>
    <template #table>
      <el-table
        v-loading="listLoading"
        ref="tableRef"
        stripe
        border
        :data="dataList"
        highlight-current-row
        @sort-change="handleSort"
      >
        <el-table-column
          label="AFF Billing Send Application No.（AFFB No.)"
          prop="affBillingAppNumber"
          fixed="left"
          align="center"
          width="220"
        />
        <el-table-column label="Date" prop="recordDate" fixed="left" align="center" width="120" />
        <el-table-column label="Affiliate Id" prop="affId" align="center" width="160" />
        <el-table-column label="Affiliate Name" prop="affName" align="center" width="160" />
        <el-table-column label="AM Id" prop="amId" align="center" width="160" />
        <el-table-column label="AM Name" prop="amName" align="center" width="160" />
        <el-table-column label="AM Email" prop="amEmail" align="center" width="160" />

        <el-table-column
          label="Aff Company Platform"
          prop="affCompanyPlatform"
          align="center"
          width="180"
        />
        <el-table-column label="Aff Entity" prop="affEntity" align="center" width="160" />
        <el-table-column label="Status" prop="auditStatus" align="center" width="180" fixed="right">
          <template #default="scope">
            <el-tag effect="dark" type="info" v-if="scope.row.auditStatus === 'UNDER_REVIEW'">
              {{ handleApplicationStatus(scope.row.auditStatus) }}
            </el-tag>
            <el-tag effect="dark" v-if="scope.row.auditStatus === 'APPROVED'">
              {{ handleApplicationStatus(scope.row.auditStatus) }}
            </el-tag>
            <el-tag effect="dark" type="danger" v-if="scope.row.auditStatus === 'REJECTED'">
              {{ handleApplicationStatus(scope.row.auditStatus) }}
            </el-tag>
            <el-tag effect="dark" type="success" v-if="scope.row.auditStatus === 'EMAIL_SENT'">
              {{ handleApplicationStatus(scope.row.auditStatus) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="Send Emails" prop="sendEmailList" align="center" width="200">
          <template #default="scope">
            <div
              v-for="(item, index) in scope.row.sendEmailList"
              :key="index"
              style="margin-top: 5px"
            >
              <el-tag>{{ item }}</el-tag>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Aff Conversion" prop="affConversion" align="center" width="180" />
        <el-table-column label="Aff Revenue" prop="affRevenue" align="center" width="150" />
        <el-table-column
          label="Aff Cover Amount"
          prop="affCoverAmount"
          align="center"
          width="180"
        />
        <el-table-column
          label="Aff Confirmed Amount"
          prop="affConfirmedAmount"
          align="center"
          width="180"
        />
        <el-table-column
          label="Aff Deduction Amount"
          prop="affDeductionAmount"
          align="center"
          width="180"
        />

        <el-table-column label="Remark" prop="remark" align="center" width="200" />
        <el-table-column label="Audit Remark" prop="auditRemark" align="center" width="200" />
        <el-table-column label="Create By" prop="createBy" align="center" width="200" />
        <el-table-column label="Create Time" prop="createTime" align="center" width="200" />
        <el-table-column label="Update By" prop="updateBy" align="center" width="200" />
        <el-table-column label="Update Time" prop="updateTime" align="center" width="200" />
      </el-table>
    </template>
    <template #pagination>
      <pagination
        class="block pagePanel"
        :pageTotal="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        :pageSize="filter.pageSize"
        :currentPage="filter.page"
      />
    </template>

    <template #dialog>
      <aff-application-base-form
        :dialogVisible.sync="dialogVisible"
        :dialogType="dialogType"
        :affBillingAppStatusList="affBillingAppStatusList"
        :editData="editData"
        :changeStatus.sync="changeStatus"
        @refresh-list="handleSearch"
      />
    </template>
  </base-list-layout>
</template>

<style scoped lang="scss"></style>
